


import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";

import usePermission from "../../config/permissions";
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    UpdatePencil,
} from "../AllSvg";

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast } from "../CustomFunctions";
import { SubCompany } from "../FilterDropdown";

// ! *************** LetterHeading Crud Models Start ***************



const AddLetterHeading = ({ getLetterHeading, subcompanyId }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            name: '',
            work_performed_by: "null",
            division: '',
        });
        setShow(false);
    };
    const handleShow = () => {
        getSubCompany();
        getDivision();
        setShow(true);
    };


    const [formData, setFormData] = useState({
        name: '',
        division: '',
        work_performed_by: 'null',

    });

    // console.log(formData.LetterHeading_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "name",
            "work_performed_by",
            "division"
        ];


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {

                let res = await axios.post(
                    `${BASE_URL}/siteproject/LetterHeading/`,
                    formData
                );

                if (res.status === 200) {
                    await getLetterHeading();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("LetterHeading added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add LetterHeading!");
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    const [divisionList, setDivisionList] = useState([]);
    const getDivision = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${subcompanyId}/`);
            setDivisionList(response.data);
        } catch (error) {
            alert(error);
        }
    }




    return (
        <>
            <button
                title="Add LetterHeading"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Letter Type Heading
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Add Letter Type Heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-from">
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="name"
                                >
                                    Name:<span className="required">*</span>
                                </label>
                                <input
                                    placeholder="Name"
                                    title="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.name
                                        ? "error"
                                        : inputState.name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Letter Type For:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="work_performed_by"
                                    value={formData.work_performed_by}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.work_performed_by
                                        ? "error"
                                        : inputState.work_performed_by
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="null">Select Letter Type for</option>
                                    <option value="contractor">Contractor</option>
                                    <option value="consultant">Consultant</option>
                                    <option value="For Both">For Both</option>


                                </select>

                                {errors.work_performed_by && (
                                    <span className="error-message">
                                        {errors.work_performed_by}
                                    </span>
                                )}
                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Division:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="division"
                                    value={formData.division}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.division
                                        ? "error"
                                        : inputState.division
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select a Division</option>
                                    {divisionList.map((company) => (
                                        <option value={company.id}>{company.name}</option>
                                    ))}
                                </select>

                                {errors.division && (
                                    <span className="error-message">
                                        {errors.division}
                                    </span>
                                )}
                            </div>


                        </div>
                    </form>
                    <div className="button-models">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Add
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateLetterHeading = ({ i, getLetterHeading, subcompanyId }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            name: '',


        });
        setShow(false);
    };
    const handleShow = () => {
        getSubCompany();
        getDivision();
        setFormData(i);
        setShow(true);
    };

    const [formData, setFormData] = useState({
        name: '',
        work_performed_by: "",
        division: '',
    });

    // console.log(formData.LetterHeading_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "name",
            'work_performed_by',
            "division"

            // formData.LetterHeading_type === "Monthbywise" ? "month" : null,
            // formData.LetterHeading_type === "Monthbywise" ? "year" : null,
            // formData.LetterHeading_type === "ProjectbyWise" ? "project" : null,
            // formData.LetterHeading_type === "ProjectbyWise" ? "employee" : null,
        ];


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {

                let res = await axios.put(
                    `${BASE_URL}/siteproject/LetterHeading/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getLetterHeading();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("LetterHeading updated successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to update LetterHeading!");
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        // if (name === "LetterHeading_type") {
        //     setFormData({
        //         ...FormData,
        //         [name]: newValue,
        //         month: "",
        //         project: "",
        //     });
        // }
        // setFormData({
        //     ...formData,
        //     [name]: newValue,
        // });
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }

    const [divisionList, setDivisionList] = useState([]);
    const getDivision = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${subcompanyId}/`);
            setDivisionList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    return (
        <>
            <button
                title="Edit LetterHeading Details"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil /> {""}

            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Update Letter Type Heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-from">
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="name"
                                >
                                    Name:<span className="required">*</span>
                                </label>
                                <input
                                    placeholder="Name"
                                    title="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.name
                                        ? "error"
                                        : inputState.name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Letter Type For:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="work_performed_by"
                                    value={formData.work_performed_by}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.work_performed_by
                                        ? "error"
                                        : inputState.work_performed_by
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="null">Select Letter Type for</option>
                                    <option value="contractor">Contractor</option>
                                    <option value="consultant">Consultant</option>
                                    <option value="For Both">For Both</option>

                                </select>

                                {errors.work_performed_by && (
                                    <span className="error-message">
                                        {errors.work_performed_by}
                                    </span>
                                )}
                            </div>



                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Division:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="division"
                                    value={formData.division}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.division
                                        ? "error"
                                        : inputState.division
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select a Division</option>
                                    {divisionList.map((company) => (
                                        <option value={company.id}>{company.name}</option>
                                    ))}
                                </select>

                                {errors.division && (
                                    <span className="error-message">
                                        {errors.division}
                                    </span>
                                )}
                            </div>


                        </div>
                    </form>
                    <div className="button-models">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Update
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



const DeleteLetterHeading = ({ i, getLetterHeading }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/LetterHeading/${i.id}/`
            );

            if (res.status === 200) {
                await getLetterHeading();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("LetterHeading deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete LetterHeading"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Letter Type Heading of "{i.name}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete LetterHeading ?
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const LetterHeading = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const subcompanyId = sessionStorage.getItem("sitemanagement_project_sub_company")

    const [toggleStatus, setToggleStatus] = useState(subcompanyId === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? "48cb62b4-9b60-4305-b6b4-b9da5d1baaf5" : "59408e4e-a455-46b6-b3db-8deaa0ae4475");
    const [LetterHeadingData, setLetterHeadingData] = useState([]);

    const getLetterHeading = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            url = `${BASE_URL}/siteproject/LetterHeadingfilter/${toggleStatus}/`;

            const sub = await axios.get(url);


            setLetterHeadingData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getLetterHeading();
    }, [toggleStatus]);

    const role = sessionStorage.getItem("role");
    const department = sessionStorage.getItem('department')

    const [toggleCompany, setToggleCompany] = useState(subcompanyId || "null")

    const [divisionData, setdivisionData] = useState([]);

    const getDivision = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            url = `${BASE_URL}/siteproject/divisionfilter/${toggleCompany}/`;

            const sub = await axios.get(url);

            setdivisionData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getDivision()
    }, [toggleCompany])
    return (
        <>



            <div className="table-css-white-background" style={{ padding: "34px 30px" }}>
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Letter Type Heading
                    </div>
                    <div className="field-cont">
                        {subcompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&

                            <SubCompany toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} />
                        }
                        <div className="table-searchh dropdown-container field-cont-div">
                            <select
                                onChange={(e) => setToggleStatus(e.target.value)}
                                value={toggleStatus}
                                className="dropdown font-size-subheading  "
                            >
                                {divisionData.map((company) => (
                                    <option value={company.id}>{company.name}</option>
                                ))}
                            </select>
                        </div>

                        <AddLetterHeading
                            getLetterHeading={getLetterHeading}
                            LetterHeadingList={LetterHeadingData}
                            subcompanyId={toggleCompany}
                        />
                    </div>
                </div>
                {/* <LetterHeadingsDetailForm /> */}
                <div className="table-box height-73vh">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr ">
                                <th className="align-left">Sr.No.</th>
                                <th className="align-center">Name</th>
                                <th className="align-center">Used For</th>


                                <th className="align-center">Division</th>
                                <th className="align-center width-5vw">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div>
                        ) : (
                            <tbody>
                                {LetterHeadingData
                                    // ?.filter((e) =>
                                    //     e.status === toggleStatus
                                    // )
                                    .sort((a, b) =>
                                        a.name.localeCompare(b.name, "en", { ignorePunctuation: true })
                                    )
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="6"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center" style={{ textTransform: "capitalize" }}>{i.name}</td>
                                                <td className="align-center" style={{ textTransform: "capitalize" }}>{i.work_performed_by || "-"}</td>

                                                <td className="align-center form-text-trasformation-uppercase">
                                                    {i.division ? i.divison_name : '-'}
                                                </td>



                                                <td className="align-center">

                                                    <div className=" flex-row justify-evenly">
                                                        <UpdateLetterHeading
                                                            i={i}
                                                            getLetterHeading={getLetterHeading}
                                                            subcompanyId={toggleCompany}
                                                        />
                                                        <DeleteLetterHeading
                                                            i={i}
                                                            getLetterHeading={getLetterHeading}
                                                        />
                                                    </div>




                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    );
};

export default LetterHeading;
